import type { SiteConfigFn } from '@wix/thunderbolt-vsm-api-types'
import type { DynamicPagesSiteConfig } from '../types'
import type { RouterConfig } from '@wix/thunderbolt-ssr-api'

const dynamicPagesSiteConfig: SiteConfigFn<DynamicPagesSiteConfig> = ({ api }) => {
	const routersConfigMap = api.rendererModel.getRouters()?.configMap ?? {}

	const validRoutersConfigMap: Record<string, RouterConfig> = {}
	for (const [routerId, routerConfig] of Object.entries(routersConfigMap)) {
		const appDefinitionId = routerConfig.appDefinitionId
		if (
			api.router.isValidWixCodeAppRouterConfig(appDefinitionId) ||
			api.router.isValidDataBindingAppRouterConfig(appDefinitionId) ||
			api.router.isValidPlatformAppRouterConfig(appDefinitionId) ||
			api.router.isValidAppRouterExtensionConfig(appDefinitionId)
		) {
			validRoutersConfigMap[routerId] = routerConfig
		}
	}

	const hasValidRouters = Object.keys(validRoutersConfigMap).length > 0
	if (!hasValidRouters) {
		return {
			shouldLoadSiteFeature: false,
			shouldLoadSiteConfig: false,
			siteConfig: null,
		}
	}

	const pagesMap = api.rendererModel.getPagesMap()

	const routerPagesSeoToIdMap: Record<string, string> = {}
	for (const routerConfig of Object.values(validRoutersConfigMap)) {
		const pages = routerConfig.pages || {}
		for (const pageId of Object.values(pages)) {
			const page = pagesMap[pageId]
			if (page) {
				routerPagesSeoToIdMap[page.pageUriSEO] = pageId
			}
		}
	}

	const prefixToRouterFetchData = api.router.getPrefixToRouterFetchDataMapping(validRoutersConfigMap)
	const externalBaseUrl = api.publicModel.getExternalBaseUrl()

	return {
		shouldLoadSiteFeature: true,
		shouldLoadSiteConfig: true,
		siteConfig: {
			prefixToRouterFetchData,
			routerPagesSeoToIdMap,
			externalBaseUrl,
		},
	}
}

const name = 'dynamicPages'

export const config = { site: dynamicPagesSiteConfig, name }
